import React from 'react';
import { EnvelopeSimple, Phone, Plus, X } from '@phosphor-icons/react';
import { mitWeiterenKanaelen, weitereKanaele, type Kanal, type KontaktKanal } from '../../lib/kontakt/kontaktKanaele';

const FELD: React.CSSProperties = {
  height: 44, borderRadius: 14, border: 'none', outline: 'none', padding: '0 12px', background: 'var(--bg)',
  boxShadow: 'inset 0 0 0 1px var(--line)', color: 'var(--ink)', fontSize: 14, fontWeight: 600, fontFamily: 'inherit', minWidth: 0,
};

/**
 * #520: Weitere E-Mail-Adressen und Telefonnummern (kontakt_kanaele, nicht primär) im neuen Design.
 * Haupt-E-Mail und Haupt-Telefon bleiben die Felder darüber; hier kommen zusätzliche Kontaktwege mit Label
 * (z. B. „Büro“, „Mobil“, „Buchhaltung“). Gespeichert wird mit dem Speichern-Knopf der Karte.
 */
export function WeitereKontaktwege({ kanaele, onChange, disabled }: {
  kanaele: KontaktKanal[];
  onChange: (kanaele: KontaktKanal[]) => void;
  disabled?: boolean;
}) {
  const weitere = weitereKanaele(kanaele);
  const setzeWeitere = (neu: KontaktKanal[]) => onChange(mitWeiterenKanaelen(kanaele, neu));
  const aendere = (i: number, patch: Partial<KontaktKanal>) => setzeWeitere(weitere.map((k, x) => (x === i ? { ...k, ...patch } : k)));
  const dazu = (kanal: Kanal) => setzeWeitere([...weitere, { kanal, wert: '', label: null, ist_primaer: false, sortierung: weitere.length + 1 }]);

  return (
    <div className="flex flex-col" style={{ gap: 8 }}>
      <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--ink3)' }}>Weitere E-Mails & Telefonnummern</span>
      {weitere.length === 0 && <span style={{ fontSize: 12.5, color: 'var(--ink3)' }}>Keine weiteren Kontaktwege hinterlegt.</span>}
      {weitere.map((k, i) => {
        const Icon = k.kanal === 'email' ? EnvelopeSimple : Phone;
        return (
          <div key={k.id ?? `neu-${i}`} className="flex items-center flex-wrap" style={{ gap: 6 }}>
            <span className="flex items-center justify-center shrink-0" style={{ width: 34, height: 34, borderRadius: 11, background: 'var(--acc-soft)' }}>
              <Icon size={15} weight="fill" color="var(--acc)" />
            </span>
            <input value={k.wert} disabled={disabled} type={k.kanal === 'email' ? 'email' : 'tel'} autoComplete="off"
              placeholder={k.kanal === 'email' ? 'weitere@adresse.de' : '+49 …'} aria-label={k.kanal === 'email' ? 'Weitere E-Mail' : 'Weitere Telefonnummer'}
              onChange={e => aendere(i, { wert: e.target.value })} style={{ ...FELD, flex: '2 1 200px' }} />
            <input value={k.label ?? ''} disabled={disabled} placeholder="Bezeichnung, z. B. Büro" aria-label="Bezeichnung"
              onChange={e => aendere(i, { label: e.target.value || null })} style={{ ...FELD, flex: '1 1 130px' }} />
            <button type="button" disabled={disabled} aria-label="Kontaktweg entfernen" title="Entfernen"
              onClick={() => setzeWeitere(weitere.filter((_, x) => x !== i))} className="flex items-center justify-center shrink-0 cursor-pointer"
              style={{ width: 36, height: 36, borderRadius: 18, border: 'none', background: 'var(--fill2)', color: 'var(--ink2)' }}>
              <X size={13} weight="bold" />
            </button>
          </div>
        );
      })}
      <div className="flex flex-wrap" style={{ gap: 6 }}>
        {([['email', 'E-Mail', EnvelopeSimple], ['telefon', 'Telefonnummer', Phone]] as const).map(([kanal, label, Icon]) => (
          <button key={kanal} type="button" disabled={disabled} onClick={() => dazu(kanal)} className="flex items-center cursor-pointer"
            style={{ height: 34, padding: '0 12px', borderRadius: 17, border: 'none', gap: 6, background: 'var(--fill2)', color: 'var(--ink)', fontSize: 12.5, fontWeight: 700, fontFamily: 'inherit' }}>
            <Plus size={12} weight="bold" /><Icon size={13} />{label}
          </button>
        ))}
      </div>
    </div>
  );
}
